import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle2, XCircle, Clock, FileText } from 'lucide-react';
import { cn } from '@/lib/utils';

export const SummaryBar: React.FC<{ total: number; posted: number; failed: number }> = ({ total, posted, failed }) => {
  const pending = Math.max(0, total - posted - failed);

  const cards = [
    {
      label: 'Total Lines', value: total, icon: FileText,
      className: 'border-border', valueClass: 'text-foreground',
    },
    {
      label: 'Posted', value: posted, icon: CheckCircle2,
      className: 'border-success-200 dark:border-success-800',
      valueClass: 'text-success-700 dark:text-success-400',
    },
    {
      label: 'Failed', value: failed, icon: XCircle,
      className: 'border-error-200 dark:border-error-800',
      valueClass: 'text-error-700 dark:text-error-400',
    },
    {
      label: 'Pending', value: pending, icon: Clock,
      className: 'border-amber-200 dark:border-amber-800',
      valueClass: 'text-amber-700 dark:text-amber-400',
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      {cards.map((card) => {
        const Icon = card.icon;
        return (
          <Card key={card.label} className={cn('border', card.className)}>
            <CardContent className="p-4">
              <div className="flex items-center gap-2 mb-1">
                <Icon className={cn('h-4 w-4', card.valueClass)} />
                <span className="text-xs font-medium text-muted-foreground">{card.label}</span>
              </div>
              <div className={cn('text-2xl font-bold', card.valueClass)}>{card.value}</div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};
